import { getLaunchAppInfo, getLaunchAppInfoBatch, launchAppInitData, launchAppInitParams } from './model';
import { LaunchAppControl } from './control';
import showLaunchAppView from './view/launch-app-dialog';
import showUserGuidView from './view/user-guid-dialog';
import showPassphraseView, { asyncShowPassphraseView } from './view/passphrase-dialog';
import { PULL_TYPE_MAP, LINK_TYPE_MAP } from './constant';
import { preLoadImage, setTrackParams, trackEvent } from './utils/common';
import { utils } from '../utils';
const launchAppInit = (launchAppInitOptionsArr, extraParams) => new Promise((resolve) => {
    const getConfigParamsArr = launchAppInitOptionsArr.map(obj => {
        const { refId, launchAppConfig = {}, getConfigOptions = {} } = obj;
        launchAppInitParams[refId] = obj;
        const { isUseWeixinTag } = launchAppConfig;
        return {
            ...getConfigOptions,
            isUseWeixinTag,
            refId
        };
    });
    getLaunchAppInfoBatch(getConfigParamsArr, extraParams)
        .then((res) => {
        resolve(res);
    });
});
// 获取拉端策略数据 + 拉端 (适用于需要实时获取拉端策略数据并执行拉端动作)
const launchAppWithData = (launchAppWithDataOptions, extraParams) => new Promise((resolve) => {
    const { refId, launchAppConfig = {}, getConfigOptions = {} } = launchAppWithDataOptions;
    const { isUseWeixinTag } = launchAppConfig;
    const getConfigParams = {
        ...getConfigOptions,
        isUseWeixinTag,
        refId,
    };
    getLaunchAppInfo(getConfigParams, extraParams)
        .then((data) => {
        const launchAppRes = data || {};
        const { pullType, // 目标动作
        mainDeepLinks, // 首拉端数据
        pullFailDeepLinks, // 候补拉端数据
        browser, // 浏览器类型 主要用于bridge拉端识别
        pullDescription, pullFailMsg } = launchAppRes;
        const strategyData = { pullType, mainDeepLinks, pullFailDeepLinks, browser, pullDescription, pullFailMsg };
        launchApp({ launchAppConfig, strategyData })
            .then((res) => {
            resolve(res);
        });
    });
    preLoadImage();
});
// 拉端 (适用于已通过prodInit或其他方式获取到拉端策略数据，只需要执行拉端动作)
const launchApp = (launchAppOptions) => new Promise((resolve, reject) => {
    const { launchAppConfig, strategyData } = launchAppOptions;
    setTrackParams(launchAppConfig?.extra?.trackParams || {});
    const { pullType } = strategyData;
    const targetAction = targetActionMap[pullType];
    targetAction && targetAction(launchAppOptions).then(res => resolve(res)).catch(err => reject(err));
    preLoadImage();
});
const copyCmd = (refId) => {
    if (refId === undefined) {
        return Promise.reject('refId必传');
    }
    const { mainDeepLinks = {}, pullFailDeepLinks = [] } = launchAppInitData[refId] || {};
    const deepLinkArr = [mainDeepLinks, ...pullFailDeepLinks];
    const deepLinkDownload = deepLinkArr.filter(linkObj => linkObj.linkType === LINK_TYPE_MAP.download)[0] || {};
    if (deepLinkDownload.linkType === LINK_TYPE_MAP.download) {
        const { cmd, extraParam = {} } = deepLinkDownload;
        if (cmd) {
            trackEvent('launch_app_command_copy_ck', { cmd, cmdId: extraParam.cmdId });
            return utils.copy(cmd).then(() => {
                return Promise.resolve();
            }).catch(() => {
                return asyncShowPassphraseView(cmd);
            });
        }
    }
    return Promise.reject();
};
// pullType对应的具体的执行动作
const targetActionMap = {
    [PULL_TYPE_MAP.launch_action]: (launchAppOptions) => new Promise((resolve, reject) => {
        const { launchAppConfig = {}, strategyData } = launchAppOptions;
        const { hadInvokeApp } = launchAppConfig;
        if (!hadInvokeApp) {
            const launchAppControl = new LaunchAppControl(launchAppOptions);
            launchAppControl.handleLaunch();
        }
        showLaunchAppView(launchAppOptions)
            .then(() => resolve(strategyData))
            .catch(() => reject(strategyData));
    }),
    [PULL_TYPE_MAP.guid_action]: (launchAppOptions) => new Promise((resolve) => {
        const { strategyData } = launchAppOptions;
        showUserGuidView();
        resolve(strategyData);
    }),
    [PULL_TYPE_MAP.no_action]: (launchAppOptions) => new Promise((resolve) => {
        const { strategyData } = launchAppOptions;
        resolve(strategyData);
    }),
    [PULL_TYPE_MAP.passphrase_action]: (launchAppOptions) => new Promise((resolve) => {
        const { strategyData } = launchAppOptions;
        const { mainDeepLinks } = strategyData;
        const { link } = mainDeepLinks;
        showPassphraseView(link);
        resolve(strategyData);
    }),
};
export { getLaunchAppInfo, launchApp, launchAppWithData, launchAppInit, copyCmd };
